// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { debounce } from 'lodash'
import { gsap, Power4 } from "gsap/all";

export default class MainMenuComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = { 
      subMenu: null,
      subContent: null,
    }
  } 

  mount() {  
    if (this.ref.subMenu) {
      this.element.addEventListener("mouseenter", debounce(this.showMenu.bind(this),100));
      this.element.addEventListener("mouseleave", debounce(this.hideMenu.bind(this),100));
    }
  }

  unmount() {
    this.hideMenu()
  }

  showMenu() {  
    const height = this.ref.subContent.offsetHeight 
    gsap.to(this.ref.subMenu,
      { 
        ease: "expo.out",
        height: height,
        onComplete: () => {
          // this.ref.subMenu.classList.remove('overflow-hidden')
        }
      }
    )
  }

  hideMenu() {  
    gsap.to(this.ref.subMenu,
      { 
        ease: "expo.in",
        height:0
      }

    )
  }


  
}
